export default {
    type: 'citation-specialisations',
    aliases: {
        camel: 'citationSpecialisations',
        singular: 'Citation Specialisations',
        plural: 'Citation Specialisation',
        lowerSingular: 'citation specialisation',
        lowerPlural: 'citation specialisations',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
